import {css} from "lit";
import {labeledTextInputStyles} from "../../common/controls-inputs/LabeledTextInput.styles.js";

export const citationInformationStyles = [labeledTextInputStyles, css`
	.citation-state-standard #citation-search-back-btn,
	.citation-state-standard #citation-search-field {
		display: none;
	}

	.citation-state-search #citation-identifier,
	.citation-state-search #citation-individual-input-fields {
		display: none;
	}

	.citation-state-unstructured #citation-search-back-btn,
	.citation-state-unstructured #citation-field-url,
	.citation-state-unstructured #citation-search-field,
	.citation-state-unstructured #citation-individual-input-fields {
		display: none;
	}

	.auto-citation-disabled #citation-identifier,
	.auto-citation-disabled #citation-format-label,
	.auto-citation-disabled #citation-format-select--wrapper,
	.auto-citation-disabled #citation-editor-warning {
		display: none;
	}

	#citation-information .two-column {
		display: flex;
		justify-content: space-between;
	}
	#citation-information .two-column pn-labeled-text-input {
		width: 48%;
	}

	#citation-identifier {
		text-align: right;
		font-weight: normal;
		margin-top: -12px;
		padding: 0 5px;
	}

	#citation-identifier ::part(button) {
		padding: 0;
	}

	#citation-search-field {
		margin-bottom: 20px;
	}

	#citation-search-back-btn {
		display: block;
		margin-top: -10px;
		margin-bottom: 20px;
	}
	#citation-search-back-btn::part(button) {
		font-weight: bolder;
		padding: 0;
	}

	#citation-search-back-btn::part(left-arrow) {
		font-size: 22px;
	}

	pn-select {
		display: block;
		margin-bottom: 20px;
	}

	#citation-format-select::part(list) {
		max-height: 290px;
	}

	#citation-format-label {
		margin-bottom: 0;
	}

	#citation-contributors-list {
		display: flex;
		flex-direction: column;
	}

	#citation-contributors-wrapper {
		margin-bottom: 20px;
	}

	#citation-contributors-wrapper label {
		margin-bottom: 0;
	}

	.citation-contributor-container {
		display: flex;
		flex-wrap: wrap;
		gap: 5px;
	}

	.citation-contributor-container pn-labeled-text-input {
		flex: 1;
	}

	.citation-contributor-delete {
		font-size: var(--pn-font-size-base);
		margin: auto;
	}

	.citation-contributor-delete::part(button) {
		padding: 6px;
	}

	.citation-contributor-container > div,
	.citation-contributor-container label,
	.citation-contributor-container ::part(label) {
		margin-bottom: 10px;
		font-weight: normal;
	}

	.citation-contributor-container .citation-contributor-select-label {
		margin-bottom: 0;
	}

	.citation-contributor-select-label + pn-select {
		display: block;
		width: 130px;
		margin-bottom: 0;
	}

	.citation-contributor-container label:not(.citation-contributor-select-label) {
		flex: 1;
	}

	#dates-container {
		margin-bottom: 20px;
	}

	pn-labeled-text-input.date-field::part(label) {
		margin-bottom: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
	}
`];
